import type { GridRowHeightParams } from '@mui/x-data-grid-pro';
import { RowHeights } from '@/shared/constants';
import type { Highlight} from '../../model/types';
import { ValueType } from '../../model/types';

export const getRowHeight =
  ({ rowHeight, highlight }: { rowHeight: RowHeights; highlight: Highlight }) =>
  (params: GridRowHeightParams) => {
    if (params.model.isTotal || highlight.valueType === ValueType.absolute) {
      return rowHeight;
    } else {
      switch (rowHeight) {
        case RowHeights.dense:
          return 38;
        case RowHeights.normal:
        case RowHeights.sparse:
        default:
          return 50;
      }
    }
  };
